import Seo from "@/components/site/Seo";
import { Cta, Notice, PageHero, Reveal, SectionHeading } from "@/components/site/kit";

const PILLARS = [
  { t: "Speed", d: "T10 is cricket at its most explosive: ten overs a side, fast decisions and a result in a single evening." },
  { t: "Local pride", d: "Franchises rooted in Telangana and Andhra Pradesh, giving regions and communities a team of their own." },
  { t: "Opportunity", d: "A structured platform for tennis-ball cricketers to be seen, selected and celebrated." },
  { t: "Partnership", d: "A commercial property built for franchise owners, sponsors and media partners to grow with the league." },
];

const FACTS = [
  ["League", "Telangana–Andhra T10 League"],
  ["Organiser", "CGN Sports"],
  ["Sport", "Tennis-ball cricket"],
  ["Format", "T10"],
  ["Planned franchises", "12"],
  ["Host cities", "Hyderabad (Telangana), Amaravati (Andhra Pradesh)"],
  ["Venues", "Two venues, one per city · names pending confirmation"],
  ["Broadcasting", "Under exploration · no broadcaster confirmed"],
];

export default function About() {
  return (
    <>
      <Seo title="About the League" description="About the Telangana–Andhra T10 League, a proposed 12-franchise T10 tennis-ball cricket league organised by CGN Sports across Hyderabad and Amaravati." />
      <PageHero testid="about-hero" eyebrow="About" title="Where Regional Cricket Meets a New Era" image="/images/crowd.jpg">
        The Telangana–Andhra T10 League is being developed by CGN Sports as a franchise-based T10 tennis-ball cricket competition. Planned across Hyderabad and Amaravati, the league aims to create opportunities for players, franchises, sponsors and cricket fans.
      </PageHero>
      <section className="container-x grid gap-14 py-20 lg:grid-cols-[1fr_1.1fr]">
        <Reveal>
          <SectionHeading eyebrow="League Fact File" title="At a Glance" />
          <dl data-testid="about-facts" className="mt-8 divide-y divide-white/10 border-y border-white/10">
            {FACTS.map(([k, v]) => (
              <div key={k} className="grid grid-cols-[140px_1fr] gap-4 py-4 text-sm sm:grid-cols-[200px_1fr]">
                <dt className="font-bold uppercase tracking-wider text-slate-400">{k}</dt>
                <dd className="text-white">{v}</dd>
              </div>
            ))}
          </dl>
        </Reveal>
        <div className="grid gap-4 sm:grid-cols-2">
          {PILLARS.map((p, i) => (
            <Reveal key={p.t} delay={i * 0.07}>
              <div className="card-lift h-full rounded-md border border-white/10 bg-[#112240] p-6">
                <span className="font-score text-sm text-[#FF5722]">0{i + 1}</span>
                <h3 className="mt-4 font-display text-3xl uppercase">{p.t}</h3>
                <p className="mt-3 text-sm text-slate-400">{p.d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <section className="container-x pb-24">
        <Notice testid="about-unconfirmed-notice">
          The league is in its development phase. Team names, venues, match dates, franchise owners, sponsors and broadcasting arrangements will only be published here once officially confirmed by CGN Sports.
        </Notice>
        <div className="mt-10 flex flex-wrap gap-4">
          <Cta to="/teams" testid="about-teams-btn">Meet the Franchises</Cta>
          <Cta to="/franchise" variant="ghost" testid="about-franchise-btn">Franchise Opportunities</Cta>
        </div>
      </section>
    </>
  );
}
